// extracted by mini-css-extract-plugin
export default {"container":"ItemsLineCutter_container__DcttO","overflowCount":"ItemsLineCutter_overflowCount__RrIAD"};